import {MyLookieroRepository} from '@domain/model/Account/MyLookiero/MyLookieroRepository';

const UpdateNextOrderDate = (repository: MyLookieroRepository, nextDate: string): Promise<void> => {
  return repository.updateNextOrderDate(nextDate);
};

export {UpdateNextOrderDate};
